import React from 'react';

import Avatar from '@atlaskit/avatar';

const AtlasAvatar = ({ image, name, onClick })=> (
	<Avatar
        name={name}
        src={image}
        presence=""
        label={name}
        onClick={onClick}
    />
);

export default AtlasAvatar;